import { render, staticRenderFns } from "./Lab_assessments.vue?vue&type=template&id=7ed52850&"
import script from "./Lab_assessments.vue?vue&type=script&lang=js&"
export * from "./Lab_assessments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports